import {
    GET_CATERING_TASKS_LIST,
} from '../../../modules/constants';

export const getCateringTasksList = (payload) => ({
    type: GET_CATERING_TASKS_LIST,
    payload,
});
